export default function loadClientResources (resources) {
    // Forms
    resources['phone-not-valid'] = "Phone number not valid.";
    resources["email"] = "e-mail";
    resources["phone"] = "Phone";
    resources["title"] = "Title";
    resources["message"] = "Message";
    resources["created-at"] = "Created at";
    
    resources["copied"] = "Copied";
    resources["image-instructions"] = <>
        <p>Drag and drop an image here</p>
        <p><small>Supported formats .gif, .jpeg, .png</small></p>
    </>;

    resources["saving"] = "Saving...";
    resources["close"] = "Close";
    resources["create-item-first"] = "Create the item before uploading the image.";
    resources["confirm-delete-heading"] = "Delete this item";
    resources["insert"] = "Insert";
    resources["create"] = "Create";
    
    resources["tables"] = "Tables";
    resources["social-type"] = "Social Type";
    resources["social-types"] = "Social Types";
    resources["social"] = "Social";
    resources["socials"] = "Socials";
    resources["stream"] = "Stream";
    resources["streams"] = "Streams";
    resources["stream-type"] = "Stream Source";
    resources["stream-types"] = "Stream Sources";
    resources["report"] = "Report";
    resources["reports"] = "Reports";
    resources["change"] = "Change";
}